import {
  GetProductReviewsRequest,
  getProductReviewsRequestToParams,
} from '../interfaces/Product/GetProductReviewsRequest';
import {
  ProductReview,
  productReviewFromResponse,
} from '../interfaces/Product/ProductReview';
import api, { apiPrefix } from './Api';
import {
  NewReview,
  newReviewOutputTransformer,
} from '../interfaces/Review/NewReview';

export const addReview = async (newReview: NewReview): Promise<void> =>
  api.post(`${apiPrefix}/review`, newReviewOutputTransformer(newReview));

export const getProductReviews = async (
  req: GetProductReviewsRequest,
): Promise<ProductReview> => {
  const response = await api.get(`${apiPrefix}/review`, {
    params: getProductReviewsRequestToParams(req),
  });

  return productReviewFromResponse(response.data);
};
